import { useDeviceType } from '@calendly/ui/hooks/use-device-type'
import { useSelector } from 'react-redux'

import { useI18n } from 'locales'
import { uniqueInviteePollVotesSelector } from 'selectors/calendars'

import { useInviteeVoteTooltip } from '../invitee_vote_tooltip'
import { sortInvitees } from '../utils'

import { Avatar } from './avatar'
import { AvatarsWrapper, AvatarWrapper, CounterWrapper, StyledLabel, Wrapper } from './styles'

const NUM_AVATARS = 3

const InviteeVoteAvatars = () => {
  const { i18n } = useI18n()
  const invitees = sortInvitees(useSelector(uniqueInviteePollVotesSelector))
  const [InviteeVoteTooltip, tooltipHostProps] = useInviteeVoteTooltip({ invitees, anchorTop: true })
  const isPhone = useDeviceType('isPhone')
  const avatarInvitees = invitees.slice(0, NUM_AVATARS).reverse()
  const counterInviteesCount = invitees.length - NUM_AVATARS

  if (invitees.length === 0 || isPhone) return null

  return (
    <Wrapper tabIndex="0" id="invitee_vote_avatars" data-testid="invitee-vote-avatars" {...tooltipHostProps}>
      <AvatarsWrapper>
        {avatarInvitees.map((invitee) => (
          <AvatarWrapper key={invitee.id}>
            <Avatar>{invitee.full_name.charAt(0).toUpperCase()}</Avatar>
          </AvatarWrapper>
        ))}
      </AvatarsWrapper>
      {counterInviteesCount > 0 && (
      <CounterWrapper>
        <Avatar hasWhiteBackground>{`+${counterInviteesCount}`}</Avatar>
      </CounterWrapper>
      )}
      <StyledLabel htmlFor="invitee_vote_avatars">{i18n.t('booking.templates.poll.votes', { count: invitees.length })}</StyledLabel>
      <InviteeVoteTooltip />
    </Wrapper>
  )
}

export default InviteeVoteAvatars
